import { render } from "./AppFooter.vue?vue&type=template&id=17ab9242&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=17ab9242&scoped=true&lang=css"

import exportComponent from "/home/jenkinsx/workspace/build-dc-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ab9242"]])

export default __exports__